import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Skin from './Skin';

const
  mapStateToProps = (state) => ({
    interactive: state.interactive,
    loadingStage: state.loadingStage,
    user: state.user,
    skin: state.skin,
    menu: state.menu,
    footer: state.footer,
  });

const
  mapDispatchToProps = (dispatch) => ({
    onLogin: (user) => {
      sessionStorage.setItem('user', JSON.stringify(user));
      dispatch({ type: 'SET_USER', user });
    },
    onLoad: (stage, callback) => {
      dispatch({
        type: 'RESET_INTERACTIVE',
        stage,
      });
      if (callback) {
        callback();
      }
    },
    onScroll: (stage) => {
      dispatch({
        type: 'SET_INTERACTIVE',
        stage,
      });
    },
    changeMenu: (isOpen) => {
      dispatch({
        type: 'SET_MENU',
        isOpen,
      });
    },
  });

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(Skin));
